export default __webpack_public_path__ + "images/Greek.e8686b.jpg";